import { Module } from "vuex";

interface NotificationState {
  hasNewNotification: boolean;
}

const notification: Module<NotificationState, any> = {
  state: {
    hasNewNotification: false,
  },

  getters: {
    getHasNewNotification(state: NotificationState): boolean {
      return state.hasNewNotification;
    },
  },
  mutations: {
    setHasNewNotification(state: NotificationState, payload: boolean) {
      state.hasNewNotification = payload;
    },
    resetHasNewNotification(state: NotificationState) {
      state.hasNewNotification = false;
    },
  },
};

export default notification;
